module.exports = __webpack_public_path__ + "img/chevron_icon_left.e8a68f37.svg";